import { render, staticRenderFns } from "./movie-add.vue?vue&type=template&id=67cce6fe&scoped=true"
import script from "./movie-add.vue?vue&type=script&lang=js"
export * from "./movie-add.vue?vue&type=script&lang=js"
import style0 from "./movie-add.vue?vue&type=style&index=0&id=67cce6fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cce6fe",
  null
  
)

export default component.exports